export interface Employee {
  id: string;
  internalId: string;
  email: string;
  name: string;
  department: string;
  userName: string;
  employeeType: EmployeeType;
  managerName: string;
  managerId: string;
  jobTitle: string;
  isActive: boolean;
  location: string;
  isActiveOnTask?: boolean;
  permissionGroups: EmployeeRole[];
  workingHours: number;
}

export interface EmployeeRole {
  id: string;
  name: RolesNamesBE;
}

export interface Department {
  name: string;
}

export enum RolesNamesBE {
  EMPLOYEE = 'Employee',
  PROJECT_MANAGER = 'ProjectManager',
  SALES_MANAGER = 'SalesManager',
  TEAM_LEAD = 'TeamLead',
  ADMIN = 'Admin',
}

export enum EmployeeType {
  EMP = 'EMP',
  CWR = 'CWR',
}

export enum RolesNames {
  EMPLOYEE = 'Employee',
  PROJECT_MANAGER = 'Project Manager',
  SALES_MANAGER = 'Backup Project Manager',
  TEAM_LEAD = 'Team Lead',
  ADMIN = 'Admin',
}

export const ROLES_ID = {
  EMPLOYEE: 'fb921c31-5f4a-4079-33d4-08dad2de603e',
  PROJECT_MANAGER: '7097af03-4e5b-4d0e-33d6-08dad2de603e',
  SALES_MANAGER: 'b4341d76-2961-4517-33d7-08dad2de603e',
  TEAM_LEAD: '3e56eea7-91ca-4321-33d5-08dad2de603e',
  ADMIN: '28999960-6682-4f90-33d3-08dad2de603e',
};

export const ROLES = {
  [RolesNamesBE.EMPLOYEE]: RolesNames.EMPLOYEE,
  [RolesNamesBE.PROJECT_MANAGER]: RolesNames.PROJECT_MANAGER,
  [RolesNamesBE.SALES_MANAGER]: RolesNames.SALES_MANAGER,
  [RolesNamesBE.TEAM_LEAD]: RolesNames.TEAM_LEAD,
  [RolesNamesBE.ADMIN]: RolesNames.ADMIN,
};

export const RoleNamesOrdered = [
  RolesNamesBE.EMPLOYEE,
  RolesNamesBE.PROJECT_MANAGER,
  RolesNamesBE.SALES_MANAGER,
  RolesNamesBE.TEAM_LEAD,
  RolesNamesBE.ADMIN,
];

export const EmployeeTypeMap = {
  [EmployeeType.EMP]: 'Employee',
  [EmployeeType.CWR]: 'Contractor',
};
